import type { UserToken } from "~/services/api-schemas";

import { Storage } from "~/utils/storage";

export const CURRENT_USER_TOKEN = Storage.key<UserToken>("current_user_token");
export const DEVICE_ID = Storage.key<string>("device_id");
export const CHANGELOG_LAST_SEEN_HASH = Storage.key<string>("changelog_last_seen_hash");
